// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"50c12d62","339":"d12ad046","642":"c5a8c49c"}[chunkId] + ".chunk.css";
};